var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpTo40(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "23px",
    viewBox: "0 0 39 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8F547A28-E6C4-47DD-9B17-2959A1392E77") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Option-2",
    transform: "translate(-86.000000, -471.000000)",
    stroke: "#0161C7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(50.892554, 442.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(24.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(11.234375, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Up-to-40",
    transform: "translate(0.152413, 0.385593)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    x: 0.5,
    y: 0.5,
    width: 37.4831544,
    height: 21.3617456,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.746410, 4.196466)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.497667289,13.3925008 L28.8846172,0.208228435",
    id: "Line"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    strokeLinejoin: "round",
    transform: "translate(2.088913, 12.497051) rotate(14.000000) translate(-2.088913, -12.497051) ",
    points: "0.974247526 10.9249255 0.495620539 14.0691772 3.68220646 13.6533051"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpTo40);
export default __webpack_public_path__ + "static/media/up_to_40.9cb527dc8ae1a5eceb75433459d49113.svg";
export { ForwardRef as ReactComponent };